module.exports = __webpack_public_path__ + "static/media/KEBAB-BTCB.b273bbed.png";